import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-openning",
  "use": "icon-icon-openning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-openning\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 512m-512 0a100 100 0 1 0 1024 0 100 100 0 1 0-1024 0Z\" p-id=\"7343\" fill=\"#f1521b\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol